<template>
  <div class="page-register flex row">

    <div class="box-left max-height flex-1">
      <div class="max-height flex middle center" >
        <div class="content w80 register-form">
          <div class="mobile">
            <div v-if="!isAdPixelPro" class="flex center middle title title-mobile">
              <img src="@/assets/img/icon.png" width="80" />
              <h1>ÚNICO TRACKER</h1>
            </div>
            <div class="margin-top-l">
              <p>
                <b>Traqueamento Avançado:</b>
              </p>
              <p class="margin-top-s"><b>VENDAS, LEADS e WHATSAPPS</b></p>
            </div>
          </div>

          <div class="margin-top-l txt-center">
            <h3>
              Crie sua conta 100% gratuito
            </h3>
          </div>
          <div class="flex middle center row margin-top-l">
            <div class="button-google UTv4vll2lG"  @click="createLoginGoogleOauth2()">
              <link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Open+Sans" />
              <div class="google-btn">
                <div class="google-icon-wrapper">
                  <img class="google-icon" src="@/assets/img/google-icon.png"/>
                </div>
                <p class="btn-text"><b>Entrar com Google</b></p>
              </div>
            </div>
            <div v-if="false" class="button-fb" style="margin-left: 18px" @click="createLoginFacebookOauth2()">
              <div class="loginBtn loginBtn--facebook">
                Entrar com Facebook
              </div>
            </div>
          </div>
  
        <div class="page-title margin-top-l">
          <p>Ou preencha as informações para criar sua conta!</p>
        </div>
  
        <!-- form -->
        <validation-observer ref="form" v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(register)">
            <div class="margin-top-l">
              <validation-provider
                name="nome"
                rules="required"
                v-slot="{ errors }"
              >
                <div
                  class="form-field item group-input "
                  :class="{ errors: errors[0] }"
                >
                  Nome
                  <input type="text" v-model="name" placeholder="Nome" />
                  <span class="erros-alert">{{ errors[0] }}</span>
                </div>
              </validation-provider>
              <validation-provider
                name="email"
                rules="required"
                v-slot="{ errors }"
              >
                <div
                  class="form-field item group-input "
                  :class="{ errors: errors[0] }"
                >
                  Email
                  <input type="email" v-model="email" placeholder="Email" />
                  <span class="erros-alert">{{ errors[0] }}</span>
                </div>
              </validation-provider>
              <validation-provider
                name="telefone"
                rules="required"
                v-slot="{ errors }"
              >
                <div
                  class="form-field item group-input "
                  :class="{ errors: errors[0] }"
                >
                  Celular (WhatsApp)
                  <the-mask
                    :mask="['(##) ####-####', '(##) #####-####']"
                    v-model="phone"
                    class="input"
                  />
                  <span class="erros-alert">{{ errors[0] }}</span>
                </div>
              </validation-provider>
  
              <validation-provider
                name="senha"
                vid="password"
                rules="required|min:8"
                v-slot="{ errors }"
              >
                <div
                  class="form-field item group-input "
                  :class="{ errors: errors[0] }"
                >
                  Senha
                  <input
                    type="password"
                    v-model="password"
                    placeholder="Senha"
                  />
                  <span class="erros-alert" v-if="passwordValidator">{{
                    passwordValidator
                  }}</span>
                </div>
              </validation-provider>
              <validation-provider
                name="repita a senha"
                rules="required|confirmed:password"
                v-slot="{ errors }"
              >
                <div
                  class="form-field item group-input margin-top-s"
                  :class="{ errors: errors[0] }"
                >
                  Repita a senha
                  <input
                    type="password"
                    v-model="password2"
                    placeholder="Repita a senha"
                  />
                  <span class="erros-alert">{{ errors[0] }}</span>
                </div>
              </validation-provider>
              
            </div>
            <div v-if="afiliate" class="form-field item margin-top-m">
              <p>
                code: {{ afiliate }}
              </p>
            </div>
            <div class="margin-top-l">
              <button
                type="submit"
                class="button primary UTv4vll2lG"
                style="width:100%"
              >
                <b>CRIAR CONTA GRÁTIS (Clique Aqui)</b>
              </button>
            </div>
            <div class="margin-top-l">
              <p>Já tenho minha conta,</p>
              <p>
                <router-link to="/" class="button light">
                  <b>
                    Entrar
                  </b>
                </router-link>
              </p>
            </div>
            <div class="txt-center margin-top-l">
              <a :href="webSite">Voltar para o Site</a>
            </div>
          </form>
        </validation-observer>
      </div>
      </div>
    </div>
    <div class="box-right max-height flex-1 no-mobile">
      <div class="max-height flex middle center column">
        <div class="content">
          <div class="right-text">
              <div>
                <div class="flex middle title column">
                  <div v-if="!isAdPixelPro" class="flex middle">
                    <img src="@/assets/img/icon.png" width="100" />
                    <h1>ÚNICO TRACKER</h1>
                  </div>
                  <div class="margin-top-s">
                    <p>
                      Trackeamento Avançado de VENDAS, LEADS E WHATSAPP
                    </p>
                    <p class="margin-top-s">Reduza em até 40% seus custos de tráfego pago. Otimizando suas campanhas</p>
                  </div>
                </div>
              </div>
            </div>
            <img class="right-img" src="@/assets/img/register-banner.png" width="500" />
        </div>
      </div>
    </div>
    <div v-if="loading" id="background-loader">
      <div class="loader" id="loader"></div>
      <div class="margin-top-l">
        <p>Criando sua conta...</p>
      </div>
    </div>
  </div>
</template>
<script>
import { 
  createAccount,
  checkIsLogged
} from "@/services/auth";


import {
  initFacebookLoginOauth2,
  initGoogleLoginOauth2,
} from "@/services/integration";

export default {
  name: "Register",
  data() {
    return {
      name: "",
      email: "",
      phone: "",
      password: "",
      password2: "",
      loading: false,
      timerToRequest: 3000,
      detectTokenDataOauth: null,
      afiliate: null,
      choicePlan: null,
    };
  },
  computed: {
    passwordValidator() {
      if (this.password && this.password.length < 8) {
        return "Mínimo 8 caracteres";
      }

      return null;
    },
    isAdPixelPro() {
        const currentDomain = window.location.hostname;
        if (currentDomain.includes("adpixel.pro")) {
          return true
        }

        return false
    },
    webSite() {
      var currentDomain = window.location.hostname;
      currentDomain = currentDomain.replace('painel.', '').replace('app.', '')
      return `https://${currentDomain}`
    },
  },
  mounted() {
    let uri = window.location.search.substring(1); 
    let params = new URLSearchParams(uri);
    this.afiliate = params.get('afid')
    
    if (!this.afiliate) {
        var itemStr = this.getCookie('kiwify-afid');
        if (itemStr) {
            this.afiliate = itemStr
        }
    }

    this.choicePlan = params.get('choicePlan')
  },
  methods: {
    getCookie(name) {
      let nameEQ = name + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let cookieArray = decodedCookie.split(';');
      for(let i = 0; i < cookieArray.length; i++) {
          let cookie = cookieArray[i].trim();
          if (cookie.indexOf(nameEQ) === 0) {
              return cookie.substring(nameEQ.length, cookie.length);
          }
      }
      return null;
    },
    register() {
      const params = {
        name: this.name,
        email: this.email,
        phone: this.phone,
        password: this.password,
        afiliate: this.afiliate,
        choicePlan: this.choicePlan,
      };

      if (this.loading) {
        return;
      }

      this.loading = true;
      createAccount(params)
        .then((response) => {
          this.trackingEvents();

          this.$store.dispatch("auth", {
            token: response.auth_token,
            account: response.account_id,
          });

          this.$toast.success({
            title: "Sucesso",
            message: "Conta criada com sucesso",
          });

          this.$router.push({ name: "Account" });
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }

          let errorDescription =
            error &&
            error.response &&
            error.response.data &&
            error.response.data.description;

          if (errorDescription === "exist-account") {
            this.$toast.error({
              title: "Erro",
              message:
                "Já existe uma conta com este e-mail. Recupere a senha ou utilize um novo e-mail",
            });
            return;
          }

          if (errorDescription === "exist-user") {
            this.$toast.error({
              title: "Erro",
              message:
                "Já existe um usuário com este e-mail. Recupere a senha ou utilize um novo e-mail",
            });
            return;
          }

          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um erro ao tentar criar a conta.",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    checkIsLogged() {
      checkIsLogged()
        .then(() => {

          this.trackingEvents();

          clearInterval(this.detectTokenDataOauth)
          setTimeout(function() {
            location.reload(true);
          }, 1500)
        })
    },
    createLoginGoogleOauth2() {
      const params = {
        afiliate: this.afiliate,
      };

      initGoogleLoginOauth2(params)
        .then((result) => {
          // set interval to refresh screen to get data
          this.detectTokenDataOauth = setInterval(() => {
            this.checkIsLogged(true);
          }, this.timerToRequest);

          this.win = window.open(
            result.url,
            "Oauth2",
            "resizable,height=800,width=600"
          );
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Falhou ao iniciar oauth",
          });
        });
    },
    createLoginFacebookOauth2() {
      const params = {
        afiliate: this.afiliate,
      };

      initFacebookLoginOauth2(params)
        .then((result) => {
          // set interval to refresh screen to get data
          this.detectTokenDataOauth = setInterval(() => {
            this.checkIsLogged(true);
          }, this.timerToRequest);

          this.win = window.open(
            result.url,
            "Oauth2",
            "resizable,height=800,width=600"
          );
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Falhou ao iniciar oauth",
          });
        });
    },
    trackingEvents() {
      // fb event
      const fbq = window.fbq;
      if (fbq) {
        fbq("track", "Lead");
        fbq('track', 'CompleteRegistration');
      }
      const gtag = window.gtag
      if (gtag) {
        gtag('event', 'conversion', {'send_to': 'AW-10928918973/rdqyCMDkwYEYEL2jqNso'});
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css?family=Poppins:400,700");

.content {
  padding:14px;
  p {
    text-align: center;
  }
}
.box-left {
  width: 100%;
  background-color: var(--bg);
}
.box-right {
  width: 100%;
  background-color: var(--terciary);
}

.form-field .item group-input {
  padding-bottom: 10px;
}
.erros-alert {
  color: red;
}

@keyframes zoominoutsinglefeatured {
  0% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1.04, 1.04);
  }
  100% {
    transform: scale(1, 1);
  }
}
.button-animate {
  animation: zoominoutsinglefeatured 1s infinite;
}

.title {
  color: #fff;
}
.title-mobile {
  color: #000;
}

.loader {
  border: 16px solid #f3f3f3; /* Light grey */
  border-top: 16px solid var(--primary);
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
}

#background-loader {
  position: fixed;
  display: flex !important;
  flex-direction: column;
  color: #fff;
  font-weight: 700;
  align-content: center;
  align-items: center;
  align-self: center;
  justify-content: center;
  z-index: 1000;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}


@media screen and (min-width: 1024px) {
  .max-height {
    height: 100vh;
  }
}


// google button

$white: #fff;
$google-blue: #4285f4;
$button-active-blue: #1669F2;

.google-btn {
  width: 184px;
  height: 42px;
  background-color: $google-blue;
  border-radius: 2px;
  box-shadow: 0 3px 4px 0 rgba(0,0,0,.25);
  .google-icon-wrapper {
    position: absolute;
    margin-top: 1px;
    margin-left: 1px;
    width: 40px;
    height: 40px;
    border-radius: 2px;
    background-color: $white;
  }
  .google-icon {
    position: absolute;
    margin-top: 11px;
    margin-left: 11px;
    width: 18px;
    height: 18px;
  }
  .btn-text {
    float: right;
    margin: 11px 11px 0 0;
    color: $white;
    font-size: 14px;
    letter-spacing: 0.2px;
    font-family: "Roboto";
  }
  &:hover {
    box-shadow: 0 0 6px $google-blue;
  }
  &:active {
    background: $button-active-blue;
  }
}

@import url(https://fonts.googleapis.com/css?family=Roboto:500);




/* Shared */
.loginBtn {
  box-sizing: border-box;
  position: relative;
  /* width: 13em;  - apply for fixed size */
  margin: 0.2em;
  padding: 0 15px 0 46px;
  border: none;
  text-align: left;
  line-height: 40px;
  white-space: nowrap;
  border-radius: 0.2em;
  font-size: 16px;
  color: #FFF;
}
.loginBtn:before {
  content: "";
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  width: 34px;
  height: 100%;
}
.loginBtn:focus {
  outline: none;
}
.loginBtn:active {
  box-shadow: inset 0 0 0 32px rgba(0,0,0,0.1);
}


/* Facebook */
.loginBtn--facebook {
  background-color: #4C69BA;
  background-image: linear-gradient(#4C69BA, #3B55A0);
  /*font-family: "Helvetica neue", Helvetica Neue, Helvetica, Arial, sans-serif;*/
  text-shadow: 0 -1px 0 #354C8C;
}
.loginBtn--facebook:before {
  border-right: #364e92 1px solid;
  background: url('https://s3-us-west-2.amazonaws.com/s.cdpn.io/14082/icon_facebook.png') 6px 6px no-repeat;
}
.loginBtn--facebook:hover,
.loginBtn--facebook:focus {
  background-color: #5B7BD5;
  background-image: linear-gradient(#5B7BD5, #4864B1);
}


/* Google */
.loginBtn--google {
  /*font-family: "Roboto", Roboto, arial, sans-serif;*/
  background: #DD4B39;
}
.loginBtn--google:before {
  border-right: #BB3F30 1px solid;
  background: url('https://s3-us-west-2.amazonaws.com/s.cdpn.io/14082/icon_google.png') 6px 6px no-repeat;
}
.loginBtn--google:hover,
.loginBtn--google:focus {
  background: #E74B37;
}

.button-fb {
  cursor:pointer;

}

.button-google {
  cursor:pointer;
}

.w80 {
  width: 80%
}

.register-form {
  max-width: 450px;
}
.grid-flex .item, .flex .item {
  padding: 0px !important
}


@media screen and (max-width: 1024px) {
  .w80 {
    width: 100%
}

}



</style>
